var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKanbanchiLogo = function SvgKanbanchiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69 11.06h.63c.253 0 .463-.033.63-.1.167-.073.31-.187.43-.34l3.99-5.05c.167-.213.34-.36.52-.44.187-.087.42-.13.7-.13h2.32l-4.87 6.01c-.287.367-.583.627-.89.78.22.08.417.193.59.34.18.14.35.327.51.56l5.02 6.77H15.9c-.32 0-.56-.043-.72-.13a1.182 1.182 0 0 1-.39-.4l-4.09-5.34a1.071 1.071 0 0 0-.44-.38c-.167-.073-.407-.11-.72-.11h-.85v4.36a2 2 0 0 1-2 2H6V5h.69a2 2 0 0 1 2 2v4.06z"
  })));
};
export default SvgKanbanchiLogo;